import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import SPImage from '@components/commons/image/SPImage';
import Description from '@components/storyDetail/summary/StoryDescription';
import { ShareStory } from '@customTypes/story';
import ShareContent from '../ShareContent';

const StorySummary = ({
  title,
  author,
  imageUrl,
  genre,
  age,
  summary,
  storyId,
}: ShareStory) => {
  const { t } = useTranslation();
  const route = useRouter();
  const showWeb = () => {
    route.push(`/story/${storyId}`);
  };

  return (
    <div css={container}>
      <div className="content">
        <div className="image-container">
          <div className="thumbnail">
            <SPImage src={imageUrl} alt="thumbnail" layout="fill" priority />
          </div>
        </div>
        <div className="title-wrapper">
          <div className="title-left">
            <h1 className="title">{title}</h1>
            <p className="author">{author}</p>
          </div>
        </div>
        <Description topic={genre} targetAge={age} oneLineDesc={summary} />
      </div>
      <ShareContent />
      <div className="bottom-button">
        <button className="button" onClick={showWeb}>
          {t('share_screen_button_move_to_story_now')}
        </button>
      </div>
    </div>
  );
};

const container = css`
  .content {
    padding: 1.25em 1.25em;
  }

  .title-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1.25em 0;
    border-bottom: 1px solid ${theme.colors.gray300};

    .title-left {
      display: flex;
      flex-direction: column;

      .title {
        font: ${theme.font.title1};
        color: ${theme.colors.gray900};
      }

      .author {
        font: ${theme.font.body2Normal};
        color: ${theme.colors.gray600};
        margin-top: 0.75em;
      }
    }
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .thumbnail {
      position: relative;
      width: 20.9375rem;
      height: 31.375rem;

      img {
        image-rendering: auto;
      }
    }
  }

  .bottom-button {
    margin: 0 auto;
    padding: 0 1em;
    position: -webkit-sticky;
    position: sticky;
    bottom: 0px;
    z-index: 2;
    background-color: ${theme.colors.white};
    border-top: 1px solid ${theme.colors.gray300};
  }

  .button {
    margin: 1em auto;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: -0.4px;
    text-align: center;
    width: 100%;
    height: 3em;
    border-radius: 0.375em;
    color: ${theme.colors.white};
    background-color: ${theme.colors.primary500};
    cursor: pointer;
  }
`;

export default StorySummary;
